import React, { ReactNode } from "react"
import * as style from './text.module.css'
import ReactMarkdown from 'react-markdown'

export default function Text({children, light, bold, small, marginBelow, inline, marginBelowLarge, large, oneBlock,}: {
    children: ReactNode;
    light?: boolean;
    bold?: boolean;
    small?: boolean;
    marginBelow?: boolean;
    inline?: boolean;
    marginBelowLarge?: boolean;
    large?: boolean;
    oneBlock?: boolean;
}) {
    const classes = [
        style.text,
        inline && style.text__i,
        marginBelow && style.text__mb,
        marginBelowLarge && style.text__mbLarge,
        bold && style.text__b,
        light && style.text__cw,
        small && style.text__s,
        large && style.l,
    ].join(' ');

    if (oneBlock) {
        return <p className={classes}>{children}</p>
    } else {
        children = (Array.isArray(children) ? children.join('') : children).split("\\n")
    
        return children.map((child, i) => !child.length ? null : <p key={child} className={classes}>{child}</p>)
    }
}

export function Markdown({children, light, bold, small, marginBelow=true, inline,}) {
    children = (Array.isArray(children) ? children.join('') : children).split("\\n")

    return children.map((child, i) => !child.length ? null : <ReactMarkdown className={[
        style.text,
        inline && style.text__i,
        marginBelow && style.text__mb,
        bold && style.text__b,
        light && style.text__cw,
        small && style.text__s,
    ].join(' ')}>{child}</ReactMarkdown>)
}